import styled from 'styled-components';

export const ChatBetaContainer = styled.div`
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (hover: hover) {
    &:hover .chat-beta-description-container {
      display: flex;
    }
  }
`;

export const ChatBetaTextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ChatBetaText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Lato;
  font-weight: 700;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 3.87px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
`;

export const ChatBetaDescriptionContainer = styled.div<{ forceOpen: boolean }>`
  z-index: 10000;
  position: absolute;
  display: none;
  flex-direction: column;
  align-items: center;
  background: black;

  top: 30px;
  border-radius: 4px;

  padding: 10px 15px;

  width: min(90vw, 366px);
  min-height: 234px;
  transition: all 0.4s ease;

  ${({ forceOpen }) => forceOpen && 'display: flex;'}
`;

export const ChatBetaDescriptionArrow = styled.div`
  position: absolute;
  left: 50%;
  top: -7px;
`;

export const ChatBetaDescriptionHeader = styled.div`
  z-index: 10000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  width: 100%;
`;

export const ChatBetaDescriptionTitle = styled.div`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`;

export const ChatBetaDescriptionBody = styled.div`
  color: #fff;

  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
